import {
  GET_DATA_ASET,
  GET_TIPE_ASET,
  SET_LOADING_DATA_ASET,
  SET_LOADING_TIPE_ASET,
  SET_PAGINATION_DATA_ASET,
  SET_PAGINATION_TIPE_ASET,
} from '../constant';

const initialState = {
  tipe: [],
  loadingTipe: false,
  tipePagination: 0,
  totalTipe: 0,
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const asetInvestasiReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_TIPE_ASET: {
      return {
        ...state,
        loadingTipe: action?.payload,
      };
    }
    case SET_PAGINATION_TIPE_ASET: {
      return {
        ...state,
        tipePagination: action?.payload,
      };
    }
    case GET_TIPE_ASET: {
      return {
        ...state,
        tipe: action?.payload?.data,
        totalTipe: action?.payload?.total,
        loadingTipe: false,
      };
    }
    case SET_LOADING_DATA_ASET: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_DATA_ASET: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_DATA_ASET: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default asetInvestasiReducer;
